<script setup lang="ts">
import type { Collections } from '@nuxt/content'

const route = useRoute();
const selectedTag: Ref<string> = ref("");

useHead({
  title: "Scripted Pixels Ltd: Work",
  meta: [
    {
      name: "description",
      content:
        "This is a timeline of my past and current work. I've worked on various projects and teams. I'm always looking for new projects to work on. I've lead small teams and work well within a team or as a solo-developer.",
    },
  ],
});

const handleSelectedTag = (tag: string) => {
  selectedTag.value = selectedTag.value === tag ? "" : tag;
};

// Create a query looking into content/articles directory
const { data: workPosts } = await useAsyncData(route.name as string, () => queryCollection(route.name as keyof Collections).where('draft', 'NOT LIKE', 'true').order('date', 'DESC').all())


// Using the work posts query to get all tags
const workTags = computed(() => {
  if (workPosts.value) {
    const allTags = workPosts.value.map((workPost) => workPost.tags).flat();
    return [...new Set(allTags)];
  } else {
    return [];
  }
});

const filteredWorkPosts = computed(() => {
  if (selectedTag.value) {
    return workPosts.value?.filter((workPost) =>
      workPost.tags.includes(selectedTag.value)
    );
  } else {
    return workPosts.value;
  }
});
</script>

<template>
  <section
    class="grid grid-cols-12 grid-flow-row gap-y-20 mt-32 md:mt-40 md:gap-y-40 md:mb-16"
  >
    <header class="col-span-12 flex flex-col space-y-4">
      <h3 class="w-full text-2xl md:text-4xl m-0">Work</h3>
      <p class="max-w-4xl m-0 text-xl">
        This is a timeline of my past and current work. I've worked on various
        projects and teams. I'm always looking for new projects to work on. I've
        lead small teams and work well within a team or as a solo-developer.
      </p>
    </header>

    <TheTagsList
      @update-selected-tag="handleSelectedTag"
      :tags="workTags"
      :selected-tag="selectedTag"
      :total-posts="workPosts?.length"
    />

    <TransitionGroup
      class="col-span-12 grid grid-cols-12 h-max gap-y-20 md:col-start-4 md:col-span-9"
      tag="ul"
      name="list-complete"
    >
      <ListItems
        v-for="post in filteredWorkPosts"
        :key="post.id"
        :post-data="post"
      />
    </TransitionGroup>
  </section>
</template>
